/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/240-evil': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M10 7a1 1 0 01-1-1l.002-.054c.032-.741.706-1.234 1.275-1.518.543-.271 1.08-.407 1.102-.413a.5.5 0 11.242.97c-.275.07-.602.189-.89.334A.998.998 0 019.999 7zM4.379 4.985a.5.5 0 11.242-.97c.023.006.559.141 1.102.413.568.284 1.243.776 1.275 1.518L7 6a1 1 0 11-1.732-.681 4.638 4.638 0 00-.89-.334zM8 11.5a3.5 3.5 0 003.002-1.699l1.286.772C11.414 12.027 9.821 13 8 13s-3.413-.973-4.288-2.427l1.286-.772A3.498 3.498 0 008 11.5zM16 1c0-.711-.149-1.387-.416-2a5.016 5.016 0 01-2.726 2.643C11.511.612 9.828 0 8.001 0s-3.51.613-4.857 1.643A5.013 5.013 0 01.418-1a4.979 4.979 0 00-.416 2c0 1.15.388 2.208 1.04 3.053a8 8 0 1013.92 0A4.979 4.979 0 0016.002 1zM8 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"/>'
  }
})
